import { BidProps } from "@/interfaces/bid_types"
import { UpdateBidButton } from "@/components/_Shared/Buttons/ProjectRouteButtons"
import { BaseExpandableRow } from "@/components/_Shared/Table/UI/ExpandableRow/ExpandableRow"
import { Description } from "@/components/Projects/Table/UI/Description"
import { OpenFolderButton } from "@/components/Buttons"
import { isOldBid } from "../Form/Utils/oldBidCheck"

export function BidRow({data}: {data: BidProps}) {
    return (
        <BaseExpandableRow>
            <div className="flex flex-row gap-5 m-5">
                <UpdateBidButton bid_id={data.bid_id ?? ""} />
                <OpenFolderButton folder_path={data.folder_location ?? ""} drive={isOldBid(data.bid_id) ? "P" : "T"} />
            </div>

            <div className="flex flex-col gap-5 p-5">
                <Description description={data.description ?? ""} />
            </div>
        </BaseExpandableRow>
    )
}